<!-- @if (isHomeRoute()) {
  <button
    type="button"
    class="fixed right-4 top-4 z-50 flex items-center gap-2 rounded-full border border-white/10 bg-slate-900/85 px-4 py-2 text-sm font-semibold text-slate-50 shadow-lg backdrop-blur-sm transition hover:bg-slate-800"
    (click)="toggleTheme()"
    [attr.aria-label]="themeMode() === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro'"
  >
    <span class="material-icons text-base">{{
      themeMode() === 'dark' ? 'light_mode' : 'dark_mode'
    }}</span>
    <span>{{ themeMode() === 'dark' ? 'Modo claro' : 'Modo oscuro' }}</span>
  </button>
} -->

<div class="bg-(--comp-app-bg) min-h-screen">
  <router-outlet></router-outlet>
  <app-load-general></app-load-general>
</div>
